import React from 'react';
import PropTypes from 'prop-types';

import HoldDataListItem from './components/holddatalistitem';

const fakeData = [
  {
    onHoldBy: 'Foo',
    onHoldOn: '1/1/20',
    holdReason: 'git gud',
    encounterProcess: '9001',
    holdReviewedBy: 'Reviewer1',
    holdReviewedOn: '1/1/20',
    holdComment: 'not gud',
    reviewComment: 'wat',
    holdRemovedOn: '1/2/20'
  },
  {
    onHoldBy: 'Bar',
    onHoldOn: '3/1/20',
    holdReason: 'no clue',
    encounterProcess: '1',
    holdReviewedBy: 'Reviewer2',
    holdReviewedOn: '3/3/20',
    holdComment: 'idk',
    reviewComment: 'how',
    holdRemovedOn: '1/2/20'
  },
  {
    onHoldBy: 'Baz',
    onHoldOn: '2/19/20',
    holdReason: 'git gud',
    encounterProcess: '9001',
    holdReviewedBy: '',
    holdReviewedOn: '',
    holdComment: 'not gud',
    reviewComment: '',
    holdRemovedOn: ''
  }
];

const HoldSection = ({
  isReview = false,
  ...props
}) => {
  const hasItems = props.holdData && props.holdData.length > 0;

  return (
    <div>
      <div>
        {
          hasItems === true
            ? props.holdData.map((x, i) => {
                return (
                  <HoldDataListItem
                    key={i}
                    {...x}
                  />
                );
              })
            : null
        }
      </div>

      <div style={{ marginTop: '2em' }}>
        <button
          onClick={props.openReviewDialog}
          disabled={
            isReview
            || (
              props.holdData && props.holdData[props.holdData.length - 1].holdStatus !== 'Pending'
            )
          }
        >
          <span>Mark as Reviewed</span>
        </button>
      </div>
    </div>
  );
};

HoldSection.propTypes = {
  holdData: PropTypes.array.isRequired,
  isReview: PropTypes.bool.isRequired,
  openReviewDialog: PropTypes.func.isRequired
};

export default HoldSection;
